module.exports = __webpack_public_path__ + "img/clock-plus.7b1813d0.svg";